// extracted by mini-css-extract-plugin
export default {"quizzes":"DPHTV","questions":"sOzqU","history":"ihMAg","progress":"Mi7Kd","container":"BCEom"};